// TODO: is there a better way than to make a new file?
export const Device = {
  mobile: "600px",
  tablet: "900px",
  desktop: "1024px",
} as const;
